<div id="content" class="mb-0">
  <img
      src="../../assets/dummy/header-livsane.jpg"
      alt="Das LIVSANE Sortiment">
  <div class="widget">
    <h2 class="pb-s">Die exklusive LIVSANE-Produktwelt – in Ihrer Apotheke</h2>
    <p>
      Seit 2017 sind wir mit unserer europaweiten Eigenmarke LIVSANE für alle Apotheken der PHOENIX group aktiv. Das Sortiment bietet qualitativ hochwertige Produkte für die ganze Familie. Zum Beispiel zur sinnvollen Nahrungsergänzung oder im Bereich der Diagnostik. LIVSANE steht für höchste Qualität durch sorgfältig ausgewählte Lieferanten - abgesichert durch permanente Qualitätskontrollen.    </p>
    <p>
      Unser Claim <strong>LIVSANE – Liebe Dein Leben</strong> steht für ein positives Lebensgefühl und schafft Identifikationspunkte. Unsere Botschaft: Das Leben ist es wert, es zu genießen. Auch, wenn nicht immer alles perfekt ist.    </p>
    <p>
      Von abenteuerlustigen Kids über unerschrockene Eltern bis hin zu smarten Senioren: Die Produktwelt von LIVSANE ist für alle da, und doch ebenso individuell wie Ihre Kundinnen und Kunden. Egal, ob im Alltag, im Beruf oder in der Freizeit: Unsere Produkte richten sich an jedes Alter und unterstützen in jeder Lebenslage.    </p>
    <h2 class="mt-l pb-s">Das LIVSANE Sortiment</h2>
    <p>
      Sie möchten Ihr Sortiment erweitern? Wählen Sie dabei aus folgenden Kategorien:
    </p>
<!--    <div class="categories">-->
<!--      <p><span class="leaf orange"></span> Gesundheit & Vorsorge</p>-->
<!--      <p><span class="leaf green"></span> Medizinprodukte</p>-->
<!--      <p><span class="leaf pink"></span> Diagnostik & Unterstützung</p>-->
<!--      <p><span class="leaf blue"></span> Erste Hilfe</p>-->
<!--      <p><span class="leaf lemon"></span> Schmerzen (OTC)</p>-->
<!--    </div>-->

    <img src="../../assets/dummy/Leistungsspektrum_Aufzaehlung.jpg" alt=""
         class="">

<!--    <div class="row mt-xxl">-->
<!--      <div class="col-md-3">-->
<!--        <a target="_blank">-->
<!--          <img src="../../assets/dummy/livsane-products.jpg"-->
<!--               class="img-border">-->
<!--        </a>-->
<!--      </div>-->
<!--      <div class="col-md align-items-center d-flex"><a-->
<!--          href="../../assets/dummy/LIVSANE%20Infos%20zu%20platzierten%20Produkten%20ApothekenTour%202024.pdf"-->
<!--          target="_blank" class="linki"><strong>LIVSANE Produktinfos</strong></a>&nbsp;-->
<!--      </div>-->
<!--      <div class="col-md align-items-center d-flex">-->
<!--        <a class="download-button btn btn-primary btn-round"-->
<!--           target="_blank">-->
<!--          <span class="arrow-helper far fa-arrow-down"></span>-->
<!--        </a>-->
<!--      </div>-->
<!--    </div>-->
    <h2 class="mt-l pb-s">Produktinfos zu LIVSANE Artikeln</h2>
    <div class="row">
      <div class="col-md-2">
        <img src="../../assets/img/product-images/600/17258300.jpg" alt="">
      </div>
      <div class="col-md-auto">
        <h4>IBUPROFEN LIVSANE 400MG</h4>
        <p class="tiny">PZN: 17258300 UVP: 3,99 €</p>
      </div>
    </div>
    <div class="row mt-l">
      <div class="col-md-2">
        <img src="../../assets/img/product-images/600/18807140.jpg" alt="">
      </div>
      <div class="col-md-10">
        <h4>LIVSANE ELEKTROLYTE</h4>
        <p class="tiny">PZN:18807140 UVP: 8,49€</p>
        <h4>Inhaltsstoffe:</h4>
        <p>Dextrose; Natriumcitrat; Natriumchlorid; Kaliumchlorid; Aromastoffe; Trennmittel: Siliziumdioxid; Süßstoff: Sucralose.</p>
        <h4>Anwendung:</h4>
        <p>
          Das Pulver von 1 Beutel in 200 ml Wasser auflösen. Bei Bedarf umrühren. Säuglinge und Kinder bis zu 10 kg: 100 ml Kinder von 11 kg bis zu 20 kg: 150 ml Erwachsene und Kinder mit einem Gewicht von mehr als 20 kg: 200 ml Die Lösung langsam und in kleinen Schlucken trinken.
        </p>
        <h4>Produktmerkmale:</h4>
        <ul>
          <li>Glutenfrei</li>
          <li>Lactosefrei</li>
          <li>Vegan</li>
        </ul>
      </div>
    </div>
    <div class="row mt-l">
      <div class="col-md-2">
        <img src="../../assets/img/product-images/600/17166213.jpg" alt="">
      </div>
      <div class="col-md-10">
        <h4>LIVSANE AUGENTROPFEN INTENSIV BEFEUCHTEND</h4>
        <p class="tiny">PZN:17166213 UVP: 9,99 €</p>
        <h4>Inhaltsstoffe:</h4>
        <p>Hyaluronsäure 0,3%, Aloe Vera Gel, Dinatriumedetat, isotonische Lösung, gepuffert auf pH-Wert 7,2</p>
        <h4>Anwendung:</h4>
        <p>
          Tropfen Sie bei Bedarf oder auf fachlichen Rat hin ein- oder mehrmals täglich ein oder zwei Tropfen in jedes Auge.
        </p>
        <h4>Produktmerkmale:</h4>
        <ul>
          <li>Für Kontaktlinsenträger geeignet</li>
          <li>Von Wärmequellen fernhalten</li>
          <li>Nach Ablauf des Verfalldatums nicht weiter verwenden</li>
        </ul>
      </div>
    </div>
    <div class="row mt-l">
      <div class="col-md-2">
        <img src="../../assets/img/product-images/600/16742732.jpg" alt="">
      </div>
      <div class="col-md-10">
        <h4>NASENSPRAY MIT DEXPANTHENOL</h4>
        <p class="tiny">PZN:16742732 UVP: 5,95 €</p>
        <h4>Inhaltsstoffe:</h4>
        <p>
          Gereinigtes Wasser, Dexpanthenol (Provitamin B5), Natriumchlorid, Kaliumdihydrogenphosphat, Dikaliumhydrogenphosphat, EDTA Di-Natriumsalz-Dihydrat, Benzalkoniumchlorid, Natriumhydroxid.
        </p>
        <h4>Anwendung:</h4>
        <p>
          Fläschchen schütteln und Schutzkappe entfernen. Beim ersten Gebrauch muss die Pumpe eventuell mehrmals betätigt werden, um einen Sprühstoß auszulösen.<br>
          Den Nasenapplikator vorsichtig in ein Nasenloch einführen und die Pumpe betätigen, um das Produkt anzuwenden. Den Applikator mit Wasser reinigen und trocknen.<br>
          Bis zur nächsten Anwendung die Schutzkappe auf den Nasenapplikator setzen. Bei Bedarf Mehrmals täglich anzuwenden.
        </p>
        <h4>Produktmerkmale:</h4>
        <ul>
          <li>Für Erwachsene und Kinder ab 1. Jahr geeignet</li>
          <li>Nach dem Öffnen 3 Monate haltbar</li>
        </ul>
      </div>
    </div>

  </div>
</div>
<section class="green-square">
  <h2>Lassen Sie sich dazu einfach von unserem Sortiment inspirieren:</h2>
  <div class="d-flex justify-content-center">
    <a>
      <button class="btn-primary on-dark-bg mr-l">
        Produktkatalog
      </button>
    </a>
    <a>
      <button class="btn-primary on-dark-bg">
        Website
      </button>
    </a>
  </div>
</section>
